import { useContext, useEffect, useRef, useState } from "react";
import Dimmer from "../scenario/scenario_equipments/Dimmer";
import Remote from "../scenario/scenario_equipments/Remote";
import FanCoil from "../scenario/scenario_equipments/FanCoil";
import ScenarioKey from "../scenario/scenario_equipments/ScenarioKey";
import RGB from "../scenario/scenario_equipments/RGB";
import Thermostat from "../scenario/scenario_equipments/Thermostat";
import Motor from "../scenario/scenario_equipments/Motor";
import WirelessKey from "../scenario/scenario_equipments/WirelessKey";
import { Context } from "../../context/Context";
import Television from "../scenario/scenario_equipments/Television";
import Key from "../scenario/scenario_equipments/Key";
import Humidity from "../scenario/scenario_equipments/Humidity";
import InputStatus from "../scenario/scenario_equipments/InputStatus";
import DataLogger from "../scenario/scenario_equipments/DataLogger";
const SelectOutputEquipment = ({
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  scenarioType,
  commands,
  setCommands,
}) => {
  const {
    setSelectOutputEquipment,
    scenarioEquipmentType,
    scenarioEquipmentId,
  } = useContext(Context);

  const modalName = useRef(null);

  useEffect(() => {
    setSelectOutputEquipment(modalName);
  }, []);

  const renderEquipment = () => {
    if (scenarioEquipmentType == 100) {
      // Television
      return (
        <Television
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
        />
      );
    } else if (scenarioEquipmentType == 3) {
      // Remote
      return (
        <Remote
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 4) {
      // Dimmer
      return (
        <Dimmer
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 501) {
      // Fan Coil
      return (
        <FanCoil
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 1) {
      // Scenario Key
      return (
        <Key
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 9997) {
      // Camera
      // return <FanCoil />
    } else if (scenarioEquipmentType == 9) {
      // RGB
      return (
        <RGB
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 1) {
      // Key
      // return (
      //   <Key
      //     equipment_id={scenarioEquipmentId}
      //     closeSelectEquipmentRef={closeSelectEquipmentRef}
      //     closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
      //   />
      // );
    } else if (scenarioEquipmentType == 5) {
      // Thermostat
      return (
        <Thermostat
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 502) {
      // Motor
      return (
        <Motor
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 99) {
      // Wireless Key
      return (
        <WirelessKey
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 503) {
      // Humidity
      return (
        <Humidity
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 9999) {
      // Humidity
      return (
        <InputStatus
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 600) {
      // Data Logger
      return (
        <DataLogger
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          setCommands={setCommands}
          commands={commands}
        />
      );
    } else if (scenarioEquipmentType == 401) {
      // Scenario Key
      return (
        <ScenarioKey
          equipment_id={scenarioEquipmentId}
          closeSelectEquipmentRef={closeSelectEquipmentRef}
          closeSelectOutputEquipmentRef={closeSelectOutputEquipmentRef}
          scenarioType={scenarioType}
          setCommands={setCommands}
          commands={commands}
        />
      );
    }
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="selectOutputModal"
      tabIndex="-1"
      aria-labelledby="selectOutputLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content h-100">
          <div className="modal-header">
            <h5 className="modal-title" id="selectOutputLable">
              انتخاب خروجی
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeSelectOutputEquipmentRef}
            ></button>
          </div>
          <div className="modal-body">{renderEquipment()}</div>
          {/* <div className="modal-footer"></div> */}
        </div>
      </div>
    </div>
  );
};

export default SelectOutputEquipment;
